import { FC, useEffect } from "react";

type tabsProps = {
  id: number;
  name: string;
  description?: string;
};

type TabsUserProps = {
  tabs: tabsProps[];
  selectedTab: number;
  handleTabChange: (tabId: number) => void;
  button?: React.ReactNode;
  initialTabIndex?: number;
};

export const TabsUser: FC<TabsUserProps> = ({
  selectedTab,
  handleTabChange,
  tabs,
  button,
  initialTabIndex,
}) => {
  useEffect(() => {
    if (
      initialTabIndex !== undefined &&
      initialTabIndex >= 0 &&
      initialTabIndex < tabs.length &&
      selectedTab !== tabs[initialTabIndex].id
    ) {
      handleTabChange(tabs[initialTabIndex].id);
    }
  }, [initialTabIndex, tabs, handleTabChange, selectedTab]);

  return (
    <div className="">
      <div className="flex-1">
        {/* Tabs para pantallas pequeñas */}
        <div className="sm:hidden">
          <label htmlFor="tabs" className="sr-only">
            Select a tab
          </label>
          <select
            id="tabs"
            name="tabs"
            value={selectedTab}
            onChange={(e) => handleTabChange(Number(e.target.value))}
            className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-primary-500 focus:outline-none focus:ring-primary-500 sm:text-sm"
          >
            {tabs?.map((tab) => (
              <option key={tab.id} value={tab.id}>
                {tab.name} {"\n"}
                {tab?.description && <span>{tab?.description}</span>}
              </option>
            ))}
          </select>
        </div>

        {/* Mostrar botón debajo de los tabs en pantallas pequeñas */}
        <div className="sm:hidden mt-4">{button && <div>{button}</div>}</div>

        {/* Tabs para pantallas grandes */}
        <div className="hidden sm:flex justify-between items-center border-b border-gray-200">
          {/* Contenedor de los tabs */}
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                className={`whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium flex flex-col items-center ${
                  selectedTab === tab.id
                    ? "border-primary-500 text-primary-600"
                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                }`}
              >
                <span>{tab.name}</span>
                {tab?.description && (
                  <span className="text-xs text-gray-400">{tab.description}</span>
                )}
              </button>
            ))}
          </nav>
          {/* Colocar el botón al lado derecho en pantallas grandes */}
          {button && <div className="ml-auto">{button}</div>}
        </div>
      </div>
    </div>
  );
};